import { Link } from 'react-router-dom';

export default function LocaleResources({ title, note, items }) {
  return (
    <section className="mb-16">
      <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-6">{title}</h2>
      <ul className="space-y-3">
        {items.map((r) => (
          <li key={r.slug}>
            <Link to={`/blog/${r.slug}`} className="text-muted-foreground font-inter hover:text-primary transition-colors">
              {r.title}{note && <span className="text-xs ml-2">{note}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}